import React, { CSSProperties, useState } from 'react'

import { useEditor, useNode } from '@craftjs/core'
import { Button, Popover, useMediaQuery } from '@mui/material'
import { LanguageSwitchProps } from '../../types/props'
import { useLanguage } from '../../contexts/RecipientContext'

import './LanguageSwitch.scss'

export const LanguageSwitch = (props: LanguageSwitchProps) => {
	const {connectors: {connect}, id} = useNode(node => ({id: node.id}))
	const { root } = useEditor((state) => ({root: state.nodes.ROOT}))
	const { language, setLanguage } = useLanguage()
	const [open, setOpen] = useState(null)
	const names: any = {
		US: 'English',
		ES: 'Espanol',
		FR: 'Francais'
	}
	const mobile = useMediaQuery('(max-width:500px)')

  const flag = (code: string) => {
		return <img loading="lazy"
			height={mobile && props.mobileFlagHeight ? props.mobileFlagHeight : props.flagHeight || 11}
			srcSet={`https://flagcdn.com/w40/${code.toLowerCase()}.png 2x`}
			src={`https://flagcdn.com/w20/${code.toLowerCase()}.png`}
			alt={code.toLowerCase()}
		/>
	}

	const display = (code: string) => {
		const style: CSSProperties = {
			display: 'flex',
			alignItems: 'center',
			padding: '5px',
			gap: '6px'
		}
    const display_style = mobile && props.mobile_display_style ? props.mobile_display_style : props.display_style

		switch (display_style) {
			case 'flag_code':
				return <div style={style}>
					{flag(code)} {code}
				</div>
			case 'flag_name':
				return <div style={style}>
					{flag(code)} {names[code]}
				</div>
			case 'code':
				return <div style={style}>
					{code}
				</div>
			case 'name':
				return <div style={style}>
					{names[code]}
				</div>
			default:
				return <div style={style}>
					{flag(code)}
				</div>
		}
	}

	return <div ref={ref => connect(ref)}
		className='dm-edit-social'
		style={{
      ...props.style,
      ...(mobile ? props.mobileStyle || {} : {})
    }}>
		<Button sx={{
        ...props.style,
        ...(mobile ? props.mobileStyle || {} : {}),
        textTransform: 'none',
        color: '#000',
        padding: '10px'
      }}
			variant="text" 
			onClick={(event) => setOpen(event.currentTarget)}>
			{ display(language) }
		</Button>
		<Popover id={id}
			open={!!open}
			anchorEl={open}
			onClose={() => setOpen(null)}
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'left',
			}}
		>
			<div style={{display: 'flex', flexDirection: 'column'}}>
				{ root.data.props.languages.map((item: {code: string}) => 
					<Button sx={{
							textTransform: 'none',
							color: '#000'
						}}
						variant="text" 
						onClick={(event) => {
							setLanguage(item.code)
							setOpen(null)
						}}>
						{ display(item.code) }
					</Button>)
				}
			</div>
		</Popover>
	</div>
}

LanguageSwitch.craft = {
	displayName: 'Language Switch'
}